/* esm.sh - applesauce-core@5.2.0/observable/defined */
import{filter as i}from"rxjs";function f(){return n=>n.pipe(i(e=>e!=null))}export{f as defined};
//# sourceMappingURL=defined.mjs.map